import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)
export default new Vuex.Store({
    state:{
        prodIdX:'', 
        productIdX:'', 
        menuIdX:'',
        leftChildIdX:'', 
        userIdX:'', 
        userChildIdX:'', 

        tabIndex:0,
        headerActive: false,
    },
    mutations:{
         changedProdId(state,val){
            state.prodIdX = val
        },
        changedProductId(state,val){
            state.productIdX = val
        },
        changedMenuId(state,val){
            state.menuIdX = val
        },
        changedLeftChildId(state,val){
            state.leftChildIdX = val
        },
        changedUserId(state,val){
            state.userIdX = val
        },
        changedUserChildId(state,val){
            state.userChildIdX = val
        },
        changedCurrentTabIndex(state,val){
            state.tabIndex = val
        },
        changedHeaderActive(state, active) {
            state.headerActive = active;
        }
    },
})